// Watercolor botanical watermarks (public/images/botanicals). Decorative only: behind content, hidden from screen readers.
const fadeX = "linear-gradient(to right, transparent 0%, black 14%, black 86%, transparent 100%)";
const fadeY = "linear-gradient(to bottom, black 25%, transparent 88%)";

// Full-width faded wash behind a page heading; the container fades out before page content begins
export const Watermark = ({ name = "wave", opacity = 0.4, height = "h-[300px] sm:h-[360px]", flip = false, testid = "botanical-watermark" }) => (
  <div aria-hidden="true" data-testid={testid}
    className={`pointer-events-none select-none absolute inset-x-0 top-0 overflow-hidden ${height}`}
    style={{ maskImage: fadeY, WebkitMaskImage: fadeY }}>
    <img src={`/images/botanicals/${name}.webp`} alt="" draggable="false"
      className={`absolute left-1/2 top-0 -translate-x-1/2 max-w-none w-[820px] sm:w-[1150px] lg:w-[1500px] ${flip ? "-scale-x-100" : ""}`}
      style={{ opacity, maskImage: fadeX, WebkitMaskImage: fadeX }} />
  </div>
);

// Soft open wreath centred behind a block of text (its centre is empty, so text stays clear)
export const WreathWatermark = () => (
  <img src="/images/botanicals/wreath.webp" alt="" aria-hidden="true" draggable="false" data-testid="botanical-wreath"
    className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-w-none w-[165%] sm:w-[132%] opacity-[0.28] sm:opacity-[0.38]" />
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`text-xs uppercase tracking-[0.3em] text-[#5E6B51] ${className}`}>{children}</p>
);
